import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { productService, categoryService, orderService } from '../../services/api';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalOrders: 0,
    totalCategories: 0,
    pendingOrders: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [products, orders, categories] = await Promise.all([
        productService.getAll(),
        orderService.getAll(),
        categoryService.getAll()
      ]);

      const pendingOrders = orders.data.data.filter(order => order.status === 'pending').length;

      setStats({
        totalProducts: products.data.data.length,
        totalOrders: orders.data.data.length,
        totalCategories: categories.data.data.length,
        pendingOrders
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8">لوحة التحكم</h1>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">إجمالي المنتجات</p>
              <p className="text-3xl font-bold text-primary">{stats.totalProducts}</p>
            </div>
            <div className="text-4xl">📦</div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">إجمالي الطلبات</p>
              <p className="text-3xl font-bold text-green-600">{stats.totalOrders}</p>
            </div>
            <div className="text-4xl">🛒</div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">الطلبات المعلقة</p>
              <p className="text-3xl font-bold text-orange-600">{stats.pendingOrders}</p>
            </div>
            <div className="text-4xl">⏳</div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">الأقسام</p>
              <p className="text-3xl font-bold text-purple-600">{stats.totalCategories}</p>
            </div>
            <div className="text-4xl">📋</div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Link
          to="/admin/products"
          className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
        >
          <h3 className="text-xl font-bold mb-2">إدارة المنتجات</h3>
          <p className="text-gray-600">إضافة، تعديل أو حذف المنتجات</p>
        </Link>

        <Link
          to="/admin/orders"
          className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
        >
          <h3 className="text-xl font-bold mb-2">إدارة الطلبات</h3>
          <p className="text-gray-600">عرض وإدارة جميع الطلبات</p>
        </Link>

        <Link
          to="/admin/categories"
          className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
        >
          <h3 className="text-xl font-bold mb-2">إدارة الأقسام</h3>
          <p className="text-gray-600">إضافة وتعديل أقسام المنتجات</p>
        </Link>
      </div>
    </div>
  );
};

export default AdminDashboard;
